var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(-0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 40,
    height: 40,
    transform: "translate(0.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pen",
    d: "M11.358,3.653l5.006,5.006L5.494,19.528l-4.463.493A.939.939,0,0,1,0,18.984l.5-4.466L11.358,3.653Zm8.1-.745L17.109.557a1.878,1.878,0,0,0-2.655,0L12.242,2.768l5.006,5.006,2.211-2.211A1.878,1.878,0,0,0,19.459,2.908Z",
    transform: "translate(10.501 9.983)",
    fill: "#95a7b1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup28);
export default __webpack_public_path__ + "static/media/Group 28.83cd1a40746d537287b3b61259337bc7.svg";
export { ForwardRef as ReactComponent };